import { withTheme } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useMemo, useEffect, useState } from 'react';

import { FovTypography } from 'components';
import { getMeshyCreditsAdmin, getTripoCreditsAdmin, getRodinCreditsAdmin } from 'store/actions/admin';
import { MemberContainer } from './styles';

const AI_MODELS = [
  { name: 'Meshy' },
  { name: 'Tripo' },
  { name: 'Rodin' },
];

const AdminAiModels = withTheme(() => {
  const dispatch = useDispatch();

  const selectedTheme = useSelector(
    state => state.userData.userPreferences.theme,
  );

  const [ cookies ] = useCookies([ 'archvision_token' ]);
  const token = cookies.archvision_token;

  const [ credits, setCredits ] = useState({
    Meshy: 'Loading...',
    Tripo: 'Loading...',
    Rodin: 'Loading...',
  });

  useEffect(() => {
    if (!token) return;

    let isMounted = true;

    Promise.all([
      dispatch(getMeshyCreditsAdmin(token)),
      dispatch(getTripoCreditsAdmin(token)),
      dispatch(getRodinCreditsAdmin(token)),
    ]).then(([ meshyRes, tripoRes, rodinRes ]) => {
      if (!isMounted) return;
      setCredits({
        Meshy: meshyRes?.credits ?? '—',
        Tripo: tripoRes?.credits ?? '—',
        Rodin: rodinRes?.credits ?? '—',
      });
    }).catch(() => {
      if (isMounted) {
        setCredits({ Meshy: '—', Tripo: '—', Rodin: '—' });
      }
    });

    return () => {
      isMounted = false;
    };
  }, [ dispatch, token ]);

  const tableData = useMemo(() => (
    AI_MODELS.map(model => ({
      ...model,
      credits: credits[model.name] ?? '—',
    }))
  ), [ credits ]);

  const columns = useMemo(() => [
    {
      title: 'Model',
      key: 'name',
      dataIndex: 'name',
      width: 200,
      render: text => <FovTypography>{text}</FovTypography>,
    },
    {
      title: 'Credits Balance',
      key: 'credits',
      dataIndex: 'credits',
      width: 200,
      render: text => <FovTypography>{text}</FovTypography>,
    },
  ], []);

  return (
    <MemberContainer
      dataSource={tableData}
      $selectedTheme={selectedTheme}
      columns={columns}
      rowKey="name"
      selectedGuid={null}
      totalCount={tableData.length}
      isPagination={false}
    />
  );
});

export default AdminAiModels;